/**
 * Checks if two arrays have the same elements (ignoring order).
 *
 * @param {Array} arr1 - The first array to compare.
 * @param {Array} arr2 - The second array to compare.
 * @returns {boolean} Returns true if the arrays have the same elements, false otherwise.
 */
const arraysHaveSameElements = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  return JSON.stringify(sortedArr1) === JSON.stringify(sortedArr2);
};

export default arraysHaveSameElements;
